'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.set = set;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET = 'domains/SET';

var initialState = {
  index: '',
  collection: {}
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET:
      return (0, _extends3.default)({}, state, action.domains);
    default:
      return state;
  }
}

function set(source) {
  var domains = {
    index: source.index,
    collection: {}
  };
  source.items.forEach(function (item) {
    domains.collection[item.domainUrl] = {
      id: item.id,
      lang: item.lang.code,
      languageName: item.lang.name,
      suffix: item.suffix
    };
  });

  return {
    type: SET,
    domains: domains
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/modules/domains.js
// module id = 1245
// module chunks = 0